import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/Elements';

export type FeatureComparatorLinkProps = {
  onComparatorLinkClick: () => void;
  actionLabel?: React.ReactNode | string;
};

export const FeatureComparatorLink = ({
  onComparatorLinkClick,
  actionLabel,
}: FeatureComparatorLinkProps) => {
  const { t } = useTranslation();

  const onDefaultClick = () => {
    onComparatorLinkClick && onComparatorLinkClick();
  };

  return (
    <span className="flex items-center justify-center bg-md-yellow">
      <Button variant="primary" size="free" onClick={onDefaultClick} className="py-4 text-base">
        {actionLabel || t('FeatureComparator.link')}
      </Button>
    </span>
  );
};
